module.exports = __webpack_public_path__ + "static/media/arrow-right-icon.20893866.svg";